import React from 'react'

export default function CommunicationHistory() {
    return (
        <div>
            CommunicationHistory
        </div>
    )
}